module.exports = __webpack_public_path__ + "fonts/Roboto-Light.319cf48.woff2";